var ReactTooltip = require("react-tooltip");
var SiteHeader = require("components/layout/SiteHeader");
var BasicSiteHeader = require("components/layout/BasicSiteHeader");
var SiteFooter = require("components/layout/SiteFooter");
var UniversalControls = require("components/layout/UniversalControls");
var ReturnAccountHeader = require("components/layout/ReturnAccountHeader");
var PendingSSOPage = require("components/technical/PendingSSOPage");
var ErrorPage = require("components/technical/ErrorPage");
var ErrorBoundary = require("components/utility/ErrorBoundary")
var CurrentUser = require("lib/account/CurrentUser");
var DemoAccountSwitcher = require("lib/account/DemoAccountSwitcher");
var RosterActions = require("lib/actions/RosterActions");
var Spinner = require("components/utility/Spinner");
var SurveyPromptUtility = require("lib/survey/SurveyPromptUtility.js");
var Modal = require("components/utility/AltModal");
var GlobalModalContainer = require("components/notifications/GlobalModalContainer.js")
var AnnouncementsConfig = require("lib/notifications/AnnouncementsConfig")

import { withRouter } from "react-router";
import { connect } from "react-redux";

require("global/vendors.scss");
require("global/app.scss");
require("global/globals.scss");
require("global/wr_styles_mixins.scss");
require("global/wr_styles.scss");
require("global/albus.scss");

@connect(
	(state, props) => ({
	}),
	(dispatch, props) => ({
		fetchOrgData: () => {
			return dispatch(RosterActions.fetchOrgData({}))
		},
	})
)

class App extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = {
			loadedCurrentUser: false,
			loadedRosterData: false
		}
	}

	renderGlobalModalContainer() {
		return <GlobalModalContainer location={this.props.location} />
	}

	// Checks if the user has any announcements and renders them on the website
	renderAnnouncements() {
		if (!CurrentUser.get() || !CurrentUser.get().user_alerts) { return };
		
		// filter user_alerts for announcements
		var announcements = _.filter(CurrentUser.get().user_alerts, a => { return a.type == ANNOUNCEMENT })
		
		// if user has announcements, render them
		if (!_.isEmpty(announcements)) { 
			return _.map(announcements, alert => {
				var path = window.location.pathname
				return AnnouncementsConfig.showAnnouncement(path, alert, CurrentUser.get())
			})
		}
	}
	
	renderPrompts() {
		if (this.showSurveyPrompts()) {
			return <SurveyPromptUtility pathname={window.location.pathname} watchContainer='#pageContent' />
		}
	}

	showSurveyPrompts() {
		return CurrentUser.get() !== undefined && !CurrentUser.get().is_student && !CurrentUser.get().is_wizard
	}

	render() {
		if (!this.state.loadedCurrentUser) {
			return (
				<div className="emptyAppContainer" />
			);
		}

		if (!this.state.loadedRosterData) {
			var pageContent = (
				<div id="pageContent">
					<Spinner placeholder={ true } scale={ 1.7 } />
				</div>
			);
			
		} else if (CurrentUser.isPendingSSOUser()) {
			var pageContent = (
				<div id="pageContent">
					<PendingSSOPage />
				</div>
			);

		} else if (CurrentUser.isOverdrawnUser()) {
			var pageContent = (
				<div id="pageContent">
					<ErrorPage which="overdrawn" />
				</div>
			);

		} else {
			var pageContent = (
				<div id="pageContent">
					{ this.props.children }
					{ this.renderPrompts() }
					{ this.renderAnnouncements() }
				</div>
			);
		}

		var path = this.props.location.pathname;

		// use basic header and no footer for upgrade page
		if (path == "/upgrade") {
			var headerContent = <BasicSiteHeader />;
		} else {
			var headerContent = <SiteHeader />;
			var footerContent = (
				<ErrorBoundary type={ "big" }>
					<SiteFooter />
				</ErrorBoundary>
			);
		}

		if (DemoAccountSwitcher.hasReturnAccount()) {
			var returnToTeacher = <ReturnAccountHeader />;
		}

		return (
			<div className="outerMostContainer">
				<div className="outerPageContainer">
					<ErrorBoundary type={ "big" }>
						{ headerContent }
						{ returnToTeacher }
					</ErrorBoundary>

					<ErrorBoundary type={ "big" } errorKey={ path }>
						{ pageContent }
						{ this.renderGlobalModalContainer() }
					</ErrorBoundary>

					<ErrorBoundary type={ "big" }>
						<UniversalControls />
					</ErrorBoundary>

				</div>
				{ footerContent }
			</div>
		);
	}

	hideLoadingContent() {
		$("#app").css("height", "100%");
		if (window.onLoadedContent) { window.onLoadedContent() }
	}

	componentDidMount() {
		$("#app").css("height", "0");
		CurrentUser.init(function(isLoggedIn) {
			if (isLoggedIn) {
				this.hideLoadingContent();
				this.setState({ loadedCurrentUser: true });
				this.props.fetchOrgData().then(() => {
					this.setState({ loadedRosterData: true });
				})
			} else {
				this.hideLoadingContent();
				this.setState({ loadedCurrentUser: true, loadedRosterData: true });
			}
		}.bind(this));

		window.redirectWorkaround = function(path) {
			this.props.history.push(path)
		}.bind(this)

		this.props.history.listen(function(location, action) {
			if (location.pathname == "/" && CurrentUser.isStudent()) {
				CurrentUser.fetchCurrentUserCoinData();
			}
			Mycroft.newPage(location.pathname);
		});

		// Hacky workaroudn for the roster page not being in redux
		$(document).on("bust-roster-cache", function() {
			// Doesn't prevent rendering, so changes might flicker
			this.props.fetchOrgData();
		}.bind(this));
	}
};

var ANNOUNCEMENT = 'Announcement'

App.WrappedComponent.propTypes = StrictPropTypes({
	children: PropTypes.PropTypes.oneOfType([
		PropTypes.object,
		PropTypes.array
	]),

	// From @connect handlers
	fetchOrgData: PropTypes.func,

	// From withRouter
	match: PropTypes.object.isRequired,
	location: PropTypes.object.isRequired,
	history: PropTypes.object.isRequired,
	staticContext: PropTypes.object,
});


module.exports = withRouter(App);


// WEBPACK FOOTER //
// ./modules/components/technical/App.js